import { connect } from 'react-redux';
import CalendarMeetingView from 'components/CalendarMeetingView/CalendarMeetingView';
import { resetCalendarEventSelection } from 'actions/Calendar';
import calendarSelectors from 'selectors/calendar';
import _get from 'lodash/get';
import { currentUserSelectors, directoryActions } from '@lifesize/nucleus';

const mapStateToProps = (state) => {
  const allEvents = calendarSelectors.lifesizeMeetingsSelector(state);
  const selectedMeetingId = calendarSelectors.selectedMeetingIdSelector(state);
  const event = allEvents.find((lifesizeMeeting) => lifesizeMeeting.id === selectedMeetingId);
  const userInfo = currentUserSelectors.myInfo(state);
  const isSelfContact = event && event.extension === userInfo.dialString;
  let contact = calendarSelectors.getSelectedCalendarContact(state);
  // populate owner and moderator object for self contact.
  if (isSelfContact && contact) {
    contact = {
      ...contact,
      owner: {
        name: userInfo.name
      },
      moderator: {
        name: userInfo.name
      }
    };
  }
  return {
    contact,
    title: _get(event, 'title'),
    extension: _get(event, 'extension'),
    organizer: _get(event, 'organizer'),
    event
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchContactByExtension: (extension) => dispatch(directoryActions.loadByExtensions(extension)),
  unselectContact: () => dispatch(resetCalendarEventSelection())
});

export default connect(mapStateToProps, mapDispatchToProps)(CalendarMeetingView);
